// extracted by mini-css-extract-plugin
module.exports = {"original":"original--343wX","minimal":"minimal--3J8we"};